import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { triggerFileDownloadByUrl, formatDateToString, showYesOrNoLabel } from '../../../../../../../helper';
import LoaderCustom from '../../../../../../common/LoaderCustom';

let llpOpcCompanyEstablishment = [1, 4, 6];

function TaxationStatutoryView(props) {
    let taxationStatutoryDetails = props.supplierDetail?.Data?.TaxationStatutoryDetails;
    let supplierDetail = props.supplierDetail?.Data;
    const [showTabLoader, setShowTabLoader] = useState(true);

    useEffect(() => {
        if (props.supplierDetail?.IsSuccessful) {
            setShowTabLoader(false);
        }
    }, [props.supplierDetail?.IsSuccessful])

    const getRegistrationCertificateLabel = (companyTypeId, domesticandOverseas) => {
        if (domesticandOverseas == 2) {
            return `Unified Social Credit Identifier (USCI)/ Business Licence Number`;
        }
        if (companyTypeId == 1) {
            return `Enter CIN Number`
        }
        if (companyTypeId == 6) {
            return `Enter OPC Number`
        }
        if (companyTypeId == 4) {
            return `Enter LLP Number`
        }
    }

    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader hl-loader-fixed" />)}
            <Row>
                <Col xs={12} md={6}>
                    <Row>
                        <Col span={12} xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h3 className="sd-common-heading">Taxation Statutory</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Year of Incorporation</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details ">{taxationStatutoryDetails?.YearOfBusinessIncorporationName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Photograph of Establishment</span>
                        </Col>
                        <Col xs={12} md={6} className="hl-descmain-details">
                            <span className="hl-desc-details pr-0">
                                {taxationStatutoryDetails?.PhotographOfEstablishName || '-'}
                                {
                                    taxationStatutoryDetails?.PhotographOfEstablish && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.PhotographOfEstablish)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>


                        {
                            (
                                supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 ||
                                (
                                    supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                                    llpOpcCompanyEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                                )
                            ) && (
                                <>
                                    <Col xs={12} md={6} className="hl-heading-details">
                                        <span className="hl-title-details">
                                            {
                                                getRegistrationCertificateLabel(supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.CompanyTypeId, supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas)
                                            }
                                        </span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details">
                                            <span className='text-uppercase'>{taxationStatutoryDetails?.CompanyRegistrationNumber || '-'}</span>
                                            {
                                                taxationStatutoryDetails?.CompanyRegistrationDocument && (
                                                    <button
                                                        className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4 ms-auto hl-mb-0`}
                                                        onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.CompanyRegistrationDocument)}
                                                        title="Download"
                                                    >
                                                        <div className="download mr-0"></div>
                                                    </button>
                                                )
                                            }
                                        </span>
                                    </Col>
                                </>
                            )
                        }
                        {
                       
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 && (
                                <>

                                    <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">PAN Number</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(taxationStatutoryDetails?.IsPanNO) && (
                                                    <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                        <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.IsPanNO)}</span>
                                                    </p>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3 pe-2 me-1`}>
                                                <span className={taxationStatutoryDetails?.IsPanNO && taxationStatutoryDetails?.PanNumber ? 'text-uppercase' : ''}>
                                                    {taxationStatutoryDetails?.IsPanNO ? taxationStatutoryDetails?.PanNumber : ''}
                                                </span>
                                                {taxationStatutoryDetails?.IsPanNO === false &&
                                                    <span className='text-start'>{taxationStatutoryDetails?.PanRemark}</span>}
                                                {
                                                    taxationStatutoryDetails?.PanNoDocument && (
                                                        <button
                                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.PanNoDocument)}
                                                            title="Download"
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </button>
                                                    )
                                                }
                                            </p>
                                        </span>
                                    </Col>

                                    <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">GSTIN Number</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(taxationStatutoryDetails?.IsGSTIN) && (
                                                    <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                        <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.IsGSTIN)}</span>
                                                    </p>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3 pe-2 me-1`}>
                                                <span className={taxationStatutoryDetails?.IsGSTIN && taxationStatutoryDetails?.GSTIN ? 'text-uppercase' : ''}>
                                                    {taxationStatutoryDetails?.IsGSTIN ? taxationStatutoryDetails?.GSTIN : ''}
                                                </span>
                                                {taxationStatutoryDetails?.IsGSTIN === false && <span className='text-start'>{taxationStatutoryDetails?.GSTINRemark}</span>}

                                                {
                                                    taxationStatutoryDetails?.GSTINDocument && (
                                                        <button
                                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.GSTINDocument)}
                                                            title="Download"
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </button>
                                                    )
                                                }
                                            </p>
                                        </span>
                                    </Col>

                                    <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">PF Number</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(taxationStatutoryDetails?.IsPFRegistration) && (
                                                    <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                        <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.IsPFRegistration)}</span>
                                                    </p>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3 pe-2 me-1`}>
                                                <span className={taxationStatutoryDetails?.PFRegistrationNumber ? "text-uppercase" : ""}>
                                                    {taxationStatutoryDetails?.PFRegistrationNumber || ''}
                                                </span>
                                                {taxationStatutoryDetails?.IsPFRegistration === false &&
                                                    <span className='text-start'>{taxationStatutoryDetails?.PFRemark}</span>}
                                                {
                                                    taxationStatutoryDetails?.PFRegistrationDocument && (
                                                        <button
                                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.PFRegistrationDocument)}
                                                            title="Download"
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </button>
                                                    )
                                                }
                                            </p>
                                        </span>
                                    </Col>

                                    <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">ESI Number</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(taxationStatutoryDetails?.IsESIRegistration) && (
                                                    <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                        <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.IsESIRegistration)}</span>
                                                    </p>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3 pe-2 me-1`}>
                                                <span className={taxationStatutoryDetails?.ESIRegistrationNumber ? "text-uppercase" : ""}>
                                                    {taxationStatutoryDetails?.ESIRegistrationNumber || ''}
                                                </span>
                                                {taxationStatutoryDetails?.IsESIRegistration === false &&
                                                    <span className='text-start'> {taxationStatutoryDetails?.ESIRemark}</span>}

                                                {
                                                    taxationStatutoryDetails?.ESIRegistrationDocument && (
                                                        <button
                                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.ESIRegistrationDocument)}
                                                            title="Download"
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </button>
                                                    )
                                                }
                                            </p>
                                        </span>
                                    </Col>
                                </>
                            )
                        }


                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Memorandum & Article of association</span>
                        </Col>
                        <Col xs={12} md={6} className="hl-descmain-details pr-0">
                            <span className="hl-desc-details">
                                {taxationStatutoryDetails?.AssociationDocumentName || '-'}
                                {
                                    taxationStatutoryDetails?.AssociationDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.AssociationDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Partnership Deed</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details">
                                {taxationStatutoryDetails?.PartnershipDeedDocumentName || '-'}
                                {
                                    taxationStatutoryDetails?.PartnershipDeedDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.PartnershipDeedDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Trust Deed</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details">
                                {taxationStatutoryDetails?.TrustDeedDocumentName || '-'}
                                {
                                    taxationStatutoryDetails?.TrustDeedDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.TrustDeedDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">
                                Any Document (if any) Attachments
                            </span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details">
                                {taxationStatutoryDetails?.AnyDocumentDocumentName || '-'}
                                {
                                    taxationStatutoryDetails?.AnyDocumentDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.AnyDocumentDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} md={6}>
                    <Row>
                        <Col span={12} xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h3 className="sd-common-heading">Certificate Information</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        {
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 && (
                                <>
                                    <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">Is your Organization Registered under Micro, Small, or Medium Enterprises (MSMED Act 2006)</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details d-block pe-0 ps-0">
                                            {
                                                showYesOrNoLabel(taxationStatutoryDetails?.IsYourOrganization) && (
                                                    <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                                        <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.IsYourOrganization)}</span>
                                                    </p>
                                                )
                                            }
                                            <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3 pe-2 me-1`}>
                                                <span className={taxationStatutoryDetails?.IsYourOrganization && taxationStatutoryDetails?.YourOrganizationRegistrationNumber ? 'text-uppercase' : ''}>
                                                    {taxationStatutoryDetails?.IsYourOrganization && taxationStatutoryDetails?.YourOrganizationRegistrationNumber ? taxationStatutoryDetails?.YourOrganizationRegistrationNumber : ''}
                                                </span>
                                                <span>{taxationStatutoryDetails?.MsmeTypeName}</span>
                                                <span className='text-uppercase'>{formatDateToString(taxationStatutoryDetails?.MsmeCertificateRegistrationDate)}</span>
                                                {
                                                    taxationStatutoryDetails?.YourOrganizationDocument && (
                                                        <button
                                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.YourOrganizationDocument)}
                                                            title="Download"
                                                        >
                                                            <div className="download mr-0"></div>
                                                        </button>
                                                    )
                                                }
                                            </p>
                                        </span>
                                    </Col>
                                </>
                            )
                        }

                        <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Do you have a Factory License?</span>
                        </Col>
                        <Col xs={12} md={6} className="hl-descmain-details">
                            <span className="hl-desc-details d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(taxationStatutoryDetails?.IsFactoryLicence) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.IsFactoryLicence)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span className={(taxationStatutoryDetails?.IsFactoryLicence && taxationStatutoryDetails?.FactoryLicenceNumber) ? 'text-uppercase' : ''}>
                                        {(taxationStatutoryDetails?.IsFactoryLicence && taxationStatutoryDetails?.FactoryLicenceNumber) ? taxationStatutoryDetails?.FactoryLicenceNumber : ''}
                                    </span>
                                    <span>{taxationStatutoryDetails?.IsFactoryLicence && formatDateToString(taxationStatutoryDetails?.FactoryLicenceExpiryDate)}</span>
                                    {
                                        (taxationStatutoryDetails?.IsFactoryLicence && taxationStatutoryDetails?.FactoryLicenceDocument) && (
                                            <button
                                                className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.FactoryLicenceDocument)}
                                                title="Download"
                                            >
                                                <div className="download mr-0"></div>
                                            </button>
                                        )
                                    }
                                </p>
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Do you have ISO 9001/IATF 16949?</span>
                        </Col>
                        <Col xs={12} md={6} className="hl-descmain-details">
                            <span className="hl-desc-details hl-multi-val text-uppercase pr-0 d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(taxationStatutoryDetails?.ISO9001) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.ISO9001)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span className={`${(taxationStatutoryDetails?.ISO9001 && taxationStatutoryDetails?.ISO9001Number) ? 'text-uppercase' : ''}`}>
                                        {(taxationStatutoryDetails?.ISO9001 && taxationStatutoryDetails?.ISO9001Number) ? taxationStatutoryDetails?.ISO9001Number : ''}
                                    </span>
                                    <span>{taxationStatutoryDetails?.ISO9001 && formatDateToString(taxationStatutoryDetails?.ISO9001ExpiryDate)}</span>
                                    {
                                        (taxationStatutoryDetails?.ISO9001 && taxationStatutoryDetails?.ISO9001Document) && (
                                            <button
                                                className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4 ms-auto hl-mb-0`}
                                                onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.ISO9001Document)}
                                                title="Download"
                                            >
                                                <div className="download mr-0"></div>
                                            </button>
                                        )
                                    }
                                </p>
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Do you have ISO 14001?</span>
                        </Col>
                        <Col xs={12} md={6} className="hl-descmain-details">
                            <span className="hl-desc-details d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(taxationStatutoryDetails?.ISO4001) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.ISO4001)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span className={(taxationStatutoryDetails?.ISO4001 && taxationStatutoryDetails?.ISO4001Number) ? 'text-uppercase' : ''}>
                                        {(taxationStatutoryDetails?.ISO4001 && taxationStatutoryDetails?.ISO4001Number) ? taxationStatutoryDetails?.ISO4001Number : ''}
                                    </span>
                                    <span>{taxationStatutoryDetails?.ISO4001 && formatDateToString(taxationStatutoryDetails?.ISO4001Expirydate)}</span>
                                    {
                                        (taxationStatutoryDetails?.ISO4001 && taxationStatutoryDetails?.ISO4001Document) && (
                                            <button
                                                className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.ISO4001Document)}
                                                title="Download"
                                            >
                                                <div className="download mr-0"></div>
                                            </button>
                                        )
                                    }
                                </p>
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Do you have ISO 26001?</span>
                        </Col>
                        <Col xs={12} md={6} className="hl-descmain-details">
                            <span className="hl-desc-details d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(taxationStatutoryDetails?.ISO26001) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.ISO26001)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span className={(taxationStatutoryDetails?.ISO26001 && taxationStatutoryDetails?.ISO26001Number) ? 'text-uppercase' : ''}>
                                        {(taxationStatutoryDetails?.ISO26001 && taxationStatutoryDetails?.ISO26001Number) ? taxationStatutoryDetails?.ISO26001Number : ''}
                                    </span>
                                    <span>{taxationStatutoryDetails?.ISO26001 && formatDateToString(taxationStatutoryDetails?.ISO26001Expirydate)}</span>
                                    {
                                        (taxationStatutoryDetails?.ISO26001 && taxationStatutoryDetails?.ISO26001Document) && (
                                            <button
                                                className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.ISO26001Document)}
                                                title="Download"
                                            >
                                                <div className="download mr-0"></div>
                                            </button>
                                        )
                                    }
                                </p>
                            </span>
                        </Col>

                        {
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 && (
                                <>
                                    <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                                        <span className="hl-title-details">Export License</span>
                                    </Col>
                                    <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                                        <span className="hl-desc-details">
                                            <span className="text-uppercase">{taxationStatutoryDetails?.ExportLicenseDocumentName || '-'}</span>
                                            {
                                                taxationStatutoryDetails?.ExportLicenseDocument && (
                                                    <button
                                                        className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                        onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.ExportLicenseDocument)}
                                                        title="Download"
                                                    >
                                                        <div className="download mr-0"></div>
                                                    </button>
                                                )
                                            }
                                        </span>
                                    </Col>
                                </>
                            )
                        }

                        <Col xs={12} md={6} className="hl-heading-details d-flex align-items-center">
                            <span className="hl-title-details">Others (If any)</span>
                        </Col>
                        <Col xs={12} md={6} className="hl-descmain-details">
                            <span className="hl-desc-details d-block pe-0 ps-0">
                                {
                                    showYesOrNoLabel(taxationStatutoryDetails?.ISOTSCertificationsOther) && (
                                        <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100`}>
                                            <span className="ps-3">{showYesOrNoLabel(taxationStatutoryDetails?.ISOTSCertificationsOther)}</span>
                                        </p>
                                    )
                                }
                                <p className={`hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100 ps-3`}>
                                    <span className={(taxationStatutoryDetails?.ISOTSCertificationsOther && taxationStatutoryDetails?.OtherCertificationNumber) ? 'text-uppercase' : ''}>
                                        {(taxationStatutoryDetails?.ISOTSCertificationsOther && taxationStatutoryDetails?.OtherCertificationNumber) ? taxationStatutoryDetails?.OtherCertificationNumber : ''}
                                    </span>
                                    <span>{taxationStatutoryDetails?.ISOTSCertificationsOther && taxationStatutoryDetails?.OtherCertificationName}</span>
                                    <span>{taxationStatutoryDetails?.ISOTSCertificationsOther && formatDateToString(taxationStatutoryDetails?.OtherCertificationExpiryDate)}</span>
                                    {
                                        (taxationStatutoryDetails?.ISOTSCertificationsOther && taxationStatutoryDetails?.OtherCertificationDocument) && (
                                            <button
                                                className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                                onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.OtherCertificationDocument)}
                                                title="Download"
                                            >
                                                <div className="download mr-0"></div>
                                            </button>
                                        )
                                    }
                                </p>
                            </span>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} md={6}>
                    <Row>
                        <Col span={12} xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h3 className="sd-common-heading">Agreement</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Suppliers Code of Conduct - Havells Group</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details">
                                {taxationStatutoryDetails?.VendorCodeOfConductName || '-'}
                                {
                                    taxationStatutoryDetails?.VendorCodeOfConduct && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.VendorCodeOfConduct)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Product Source Agreement/Job work agreement</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details">
                                {taxationStatutoryDetails?.ProductSourcingDocumentName || '-'}
                                {
                                    taxationStatutoryDetails?.ProductSourcingDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.ProductSourcingDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Other Agreement (If any)</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details">
                                {taxationStatutoryDetails?.OtherAgreementDocumentName || '-'}
                                {
                                    taxationStatutoryDetails?.OtherAgreementDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, taxationStatutoryDetails?.OtherAgreementDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}

export default TaxationStatutoryView